import { Injectable } from '@angular/core';
import { environmentConfig } from '@lpl/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService extends environmentConfig {

//   static appCustom: string = ConfigService.getPropertyValue('appCustom');
  static frBaseUrl:string = ConfigService.getPropertyValue('frBaseUrl');
  static realmPath:string = ConfigService.getPropertyValue('realmPath');
  static authOWA_Url:string = ConfigService.getPropertyValue('authOWA_Url');

  constructor() {
    super();
  }
}
